import { IAssemblyApplicationTypeResponse } from '@kcftech/prometheus-client';
import { skipToken, UseQueryOptions, useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

export const assemblyTypeQueryKey = 'assembly-type';

export function useAssemblyType(
    assemblyTypeId?: number,
    queryOptions?: UseQueryOptions<IAssemblyApplicationTypeResponse | undefined>,
) {
    return useQuery({
        queryKey: [assemblyTypeQueryKey, assemblyTypeId],

        queryFn:
            assemblyTypeId !== undefined
                ? () =>
                      sdClient.getAssemblyApplicationType({
                          applicationTypeId: assemblyTypeId,
                      })
                : skipToken,

        ...queryOptions,
    });
}

export function invalidateAssemblyType(assemblyTypeId: number) {
    queryClient.invalidateQueries({
        queryKey: [assemblyTypeQueryKey, assemblyTypeId],
    });
}
